import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

import { SubscriptionService } from 'shared/subscription/subscription.service';
import { BrandService } from 'shared/brand/brand.service';
import { UserService } from 'shared/user/user.service';
import { prettifyNumber } from 'utils/prettify';

import * as moment from 'moment';

@Component({
  moduleId: module.id,
  selector: 'sd-get-started',
  templateUrl: 'get-started.component.html',
  styleUrls: ['get-started.component.scss'],
})
export class GetStartedComponent implements OnInit {

  name: string;
  isSidedrawerDisabled: boolean = true; // use this field to disable/enable sidedrawer

  constructor(
    private userService: UserService,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private brandService: BrandService,
  ) {}

  get brandId(): string {
    return this.brandService.getBrand();
  }

  // hooks
  ngOnInit() {
    this.init();
  }

  // handlers:
  onCompleteSetupClick() {
    this.router.navigate(['/account-information/billing/flow']);
  }

  // private:
  private refresh() {
    this.userService.getUser()
    .subscribe((data: any) => {
      this.name = data.first_name;
    });
  }

  private init() {
    forkJoin([
      this.subscriptionService.getSubscription(this.brandId),
      this.subscriptionService.getAccountBrand(this.brandId),
    ])
    .subscribe((res) => {
        const canActivate = false;
        const redirectTo = null;
        const subscription = res[0];
        const accountBrand = res[1];

        if (accountBrand.paywall_on_at && moment().isBefore(accountBrand.paywall_on_at)) {
          this.router.navigate(['/']);
        } else if (subscription.valid) {
          this.router.navigate(['/']);
        } else {
          this.refresh();
        }
      });
  }
}
